module.exports = __webpack_public_path__ + "media/images/xpass/landing_page/achievements-mobile-b50204abf0efde49d5f49a326fdf6653.png";